"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var DatePickerWrapper_1 = __importDefault(require("./styledComponents/DatePickerWrapper"));
var DatePicker_meta_1 = require("./DatePicker.meta");
var DatePickerUtils_1 = require("./DatePickerUtils");
var mobx_1 = require("mobx");
var DatePickerInput_1 = __importDefault(require("./components/DatePickerInput"));
var DatePickerMonth_1 = __importDefault(require("./components/DatePickerMonth"));
var Dialog_1 = __importDefault(require("./styledComponents/Dialog"));
var DialogContent_1 = __importDefault(require("./styledComponents/DialogContent"));
var Mobile_1 = __importDefault(require("./styledComponents/Mobile"));
var MobileHeading_1 = __importDefault(require("./styledComponents/MobileHeading"));
var ButtonClose_1 = __importDefault(require("./styledComponents/ButtonClose"));
var Header_1 = __importDefault(require("./styledComponents/Header"));
var SelectWrapper_1 = __importDefault(require("./styledComponents/SelectWrapper"));
var SelectMonth_1 = __importDefault(require("./styledComponents/SelectMonth"));
var SelectLabel_1 = __importDefault(require("./styledComponents/SelectLabel"));
var SelectYear_1 = __importDefault(require("./styledComponents/SelectYear"));
var NavigationWrapper_1 = __importDefault(require("./styledComponents/NavigationWrapper"));
var ButtonPrevious_1 = __importDefault(require("./styledComponents/ButtonPrevious"));
var ButtonNext_1 = __importDefault(require("./styledComponents/ButtonNext"));
var ClickLayer_1 = __importDefault(require("../ClickLayer"));
var Image_1 = __importDefault(require("../Image"));
var Translate_1 = __importDefault(require("../Translate"));
var Translate_2 = require("../Translate/Translate");
var DISALLOWED_CHARACTERS = /[^0-9\.\/\-]+/g;
var TRANSITION_MS = 300;
function range(from, to) {
    var result = [];
    for (var i = from; i <= to; i++) {
        result.push(i);
    }
    return result;
}
var keyCode = {
    TAB: 9,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
};
function cleanValue(input, regex) {
    var value = input.value || '';
    var cursor = input.selectionStart || undefined;
    var beforeCursor = value.slice(0, cursor);
    var afterCursor = value.slice(cursor, value.length);
    var filteredBeforeCursor = beforeCursor.replace(regex, '');
    var filterAfterCursor = afterCursor.replace(regex, '');
    var newValue = filteredBeforeCursor + filterAfterCursor;
    var newCursor = filteredBeforeCursor.length;
    input.value = newValue;
    input.selectionStart = input.selectionEnd = newCursor;
    return newValue;
}
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = DatePicker_meta_1.DATE_PICKER_CATEGORY_KEY;
        _this.componentKey = DatePicker_meta_1.DATE_PICKER_COMPONENT_KEY;
        /**
         * observable variables
         */
        _this.activeFocus = false;
        _this.focusedDay = new Date();
        _this.open = false;
        /**
         * Own Properties
         */
        _this.monthSelectId = DatePickerUtils_1.createIdentifier('KsysDateMonth');
        _this.yearSelectId = DatePickerUtils_1.createIdentifier('KsysDateYear');
        _this.dialogLabelId = DatePickerUtils_1.createIdentifier('KsysDateLabel');
        _this.initialTouchX = null;
        _this.initialTouchY = null;
        /**
           * Whilst dateAdapter is used for handling the formatting/parsing dates in the input,
           * these are used to format dates exclusively for the benefit of screen readers.
           *
           * We prefer DateTimeFormat over date.toLocaleDateString, as the former has
           * better performance when formatting large number of dates. See:
           * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString#Performance
           */
        _this.dateFormatShort = new Intl.DateTimeFormat();
        _this.dateFormatLong = new Intl.DateTimeFormat();
        _this.componentDidUpdate = function (prev) {
            if (prev.value !== _this.props.value) {
                _this.value = _this.props.value;
                _this.valueAsDate = DatePickerUtils_1.parseISODate(_this.value);
            }
        };
        _this.createDateFormatters = function () {
            var _a = _this.props, localization = _a.localization, dateFormatShort = _a.dateFormatShort, dateFormatLong = _a.dateFormatLong;
            _this.dateFormatShort = new Intl.DateTimeFormat(localization.locale, dateFormatShort || { day: 'numeric', month: 'long' });
            _this.dateFormatLong = new Intl.DateTimeFormat(localization.locale, dateFormatLong || {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
            });
        };
        /**
           * Public methods API
           */
        /**
         * Sets focus on the date picker's input. Use this method instead of the global `focus()`.
         */
        _this.setFocus = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.datePickerInput && this.datePickerInput.current.focus()];
            });
        }); };
        /**
         * Show the calendar modal, moving focus to the calendar inside.
         */
        _this.show = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.open = true;
                this.setFocusedDay(DatePickerUtils_1.parseISODate(this.value) || new Date());
                if (this.focusTimeoutId) {
                    clearTimeout(this.focusTimeoutId);
                }
                this.focusTimeoutId = setTimeout(function () { return _this.monthSelectNode && _this.monthSelectNode.current.focus(); }, TRANSITION_MS);
                return [2 /*return*/];
            });
        }); };
        /**
         * Hide the calendar modal. Set `moveFocusToButton` to false to prevent focus
         * returning to the date picker's button. Default is true.
         */
        _this.hide = function (moveFocusToButton) {
            if (moveFocusToButton === void 0) { moveFocusToButton = true; }
            return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    this.open = false;
                    // in cases where calendar is quickly shown and hidden
                    // we should avoid moving focus to the button
                    if (this.focusTimeoutId) {
                        clearTimeout(this.focusTimeoutId);
                    }
                    if (moveFocusToButton) {
                        // iOS VoiceOver needs to wait for all transitions to finish.
                        setTimeout(function () { return _this.datePickerButton && _this.datePickerButton.current.focus(); }, TRANSITION_MS + 200);
                    }
                    return [2 /*return*/];
                });
            });
        };
        /**
      * Local methods.
      */
        _this.enableActiveFocus = function () {
            _this.activeFocus = true;
        };
        _this.disableActiveFocus = function () {
            _this.activeFocus = false;
        };
        _this.startOfWeek = function () {
            _this.setFocusedDay(DatePickerUtils_1.startOfWeek(_this.focusedDay, _this.props.firstDayOfWeek));
        };
        _this.endOfWeek = function () {
            _this.setFocusedDay(DatePickerUtils_1.endOfWeek(_this.focusedDay, _this.props.firstDayOfWeek));
        };
        _this.setFocusedDay = function (day) {
            var _a = _this.props, min = _a.min, max = _a.max;
            _this.focusedDay = DatePickerUtils_1.clamp(day, DatePickerUtils_1.parseISODate(min), DatePickerUtils_1.parseISODate(max));
        };
        _this.toggleOpen = function (e) {
            e.preventDefault();
            _this.open ? _this.hide(false) : _this.show();
        };
        _this.handleEscKey = function (event) {
            if (event.keyCode === keyCode.ESC) {
                _this.hide();
            }
        };
        _this.handleBlur = function (event) {
            event.stopPropagation();
        };
        _this.handleFocus = function (event) {
            event.stopPropagation();
        };
        // TODO: Implement touch events for mobile
        // @action
        // private handleTouchStart = (event: TouchEvent): any => {
        // 	const touch = event.changedTouches[0];
        // 	this.initialTouchX = touch.pageX;
        // 	this.initialTouchY = touch.pageY;
        // }
        // private handleTouchMove = (event: TouchEvent): any => {
        // 	event.preventDefault();
        // }
        // @action
        // private handleTouchEnd = (event: TouchEvent): any => {
        // 	const touch = event.changedTouches[0];
        // 	const distX = touch.pageX - (this.initialTouchX || 0); // get horizontal dist traveled
        // 	const distY = touch.pageY - (this.initialTouchY || 0); // get vertical dist traveled
        // 	const threshold = 70;
        // 	const isHorizontalSwipe = Math.abs(distX) >= threshold && Math.abs(distY) <= threshold;
        // 	const isDownwardsSwipe = Math.abs(distY) >= threshold && Math.abs(distX) <= threshold && distY > 0;
        // 	if (isHorizontalSwipe) {
        // 		this.addMonths(distX < 0 ? 1 : -1);
        // 	}
        // 	else if (isDownwardsSwipe) {
        // 		this.hide(false);
        // 		event.preventDefault();
        // 	}
        // 	this.initialTouchY = null;
        // 	this.initialTouchX = null;
        // }
        _this.handleNextMonthClick = function (event) {
            event.preventDefault();
            _this.addMonths(1);
        };
        _this.handlePreviousMonthClick = function (event) {
            event.preventDefault();
            _this.addMonths(-1);
        };
        _this.handleFirstFocusableKeydown = function (event) {
            // this ensures focus is trapped inside the dialog
            if (event.keyCode === keyCode.TAB && event.shiftKey && _this.focusedDayNode) {
                _this.focusedDayNode.focus();
                event.preventDefault();
            }
        };
        _this.handleKeyboardNavigation = function (event) {
            // handle tab separately, since it needs to be treated
            // differently to other keyboard interactions
            if (event.keyCode === keyCode.TAB && !event.shiftKey && _this.firstFocusableElement) {
                event.preventDefault();
                _this.firstFocusableElement.current.focus();
                return;
            }
            var handled = true;
            switch (event.keyCode) {
                case keyCode.RIGHT:
                    _this.addDays(1);
                    break;
                case keyCode.LEFT:
                    _this.addDays(-1);
                    break;
                case keyCode.DOWN:
                    _this.addDays(7);
                    break;
                case keyCode.UP:
                    _this.addDays(-7);
                    break;
                case keyCode.PAGE_UP:
                    if (event.shiftKey) {
                        _this.addYears(-1);
                    }
                    else {
                        _this.addMonths(-1);
                    }
                    break;
                case keyCode.PAGE_DOWN:
                    if (event.shiftKey) {
                        _this.addYears(1);
                    }
                    else {
                        _this.addMonths(1);
                    }
                    break;
                case keyCode.HOME:
                    _this.startOfWeek();
                    break;
                case keyCode.END:
                    _this.endOfWeek();
                    break;
                default:
                    handled = false;
            }
            if (handled) {
                event.preventDefault();
                _this.enableActiveFocus();
            }
        };
        _this.handleDaySelect = function (e, day) {
            var _a = _this.props, min = _a.min, max = _a.max, isDateDisabled = _a.isDateDisabled;
            var isInRange = DatePickerUtils_1.inRange(day, DatePickerUtils_1.parseISODate(min), DatePickerUtils_1.parseISODate(max));
            var isAllowed = !isDateDisabled(day);
            if (isInRange && isAllowed) {
                _this.setValue(day);
                _this.hide();
            }
            else {
                // for consistency we should set the focused day in cases where
                // user has selected a day that has been specifically disallowed
                _this.setFocusedDay(day);
            }
        };
        _this.handleMonthSelect = function (e) {
            if (e.target) {
                _this.setMonth(parseInt(e.target.value, 10));
            }
        };
        _this.handleYearSelect = function (e) {
            if (e.target) {
                _this.setYear(parseInt(e.target.value, 10));
            }
        };
        _this.handleInputChange = function (e) {
            var dateAdapter = _this.props.dateAdapter;
            var target = _this.datePickerInput.current;
            if (target) {
                // clean up any invalid characters
                cleanValue(target, DISALLOWED_CHARACTERS);
                var parsed = dateAdapter.parse(target.value, DatePickerUtils_1.createDate);
                if (parsed) {
                    _this.setValue(parsed);
                }
            }
        };
        _this.processFocusedDayNode = function (element) {
            _this.focusedDayNode = element;
            if (_this.activeFocus && _this.open) {
                setTimeout(function () { return element.focus(); }, 0);
            }
        };
        _this.datePickerButton = react_1.default.createRef();
        _this.datePickerInput = react_1.default.createRef();
        _this.firstFocusableElement = react_1.default.createRef();
        _this.monthSelectNode = react_1.default.createRef();
        _this.dialogWrapperNode = react_1.default.createRef();
        // this.handleDocumentClick = this.handleDocumentClick.bind(this);
        // addEventListener('click', this.handleDocumentClick);
        _this.value = props.value;
        _this.valueAsDate = DatePickerUtils_1.parseISODate(props.value);
        _this.createDateFormatters();
        return _this;
    }
    DatePicker.prototype.addDays = function (days) {
        this.setFocusedDay(DatePickerUtils_1.addDays(this.focusedDay, days));
    };
    DatePicker.prototype.addMonths = function (months) {
        this.setMonth(this.focusedDay.getMonth() + months);
    };
    DatePicker.prototype.addYears = function (years) {
        this.setYear(this.focusedDay.getFullYear() + years);
    };
    DatePicker.prototype.setMonth = function (month) {
        var min = DatePickerUtils_1.setMonth(DatePickerUtils_1.startOfMonth(this.focusedDay), month);
        var max = DatePickerUtils_1.endOfMonth(min);
        var date = DatePickerUtils_1.setMonth(this.focusedDay, month);
        this.setFocusedDay(DatePickerUtils_1.clamp(date, min, max));
    };
    DatePicker.prototype.setYear = function (year) {
        var min = DatePickerUtils_1.setYear(DatePickerUtils_1.startOfMonth(this.focusedDay), year);
        var max = DatePickerUtils_1.endOfMonth(min);
        var date = DatePickerUtils_1.setYear(this.focusedDay, year);
        this.setFocusedDay(DatePickerUtils_1.clamp(date, min, max));
    };
    DatePicker.prototype.setValue = function (date) {
        this.value = DatePickerUtils_1.printISODate(date);
        this.valueAsDate = DatePickerUtils_1.parseISODate(this.value);
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(this.value);
        }
    };
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, dateAdapter = _a.dateAdapter, min = _a.min, max = _a.max, direction = _a.direction, localization = _a.localization, _b = _a.name, name = _b === void 0 ? 'date' : _b, disabled = _a.disabled, role = _a.role, required = _a.required, identifier = _a.identifier, firstDayOfWeek = _a.firstDayOfWeek, isDateDisabled = _a.isDateDisabled;
        var formattedDate = this.valueAsDate && dateAdapter.format(this.valueAsDate);
        var selectedYear = (this.valueAsDate || this.focusedDay).getFullYear();
        var focusedMonth = this.focusedDay.getMonth();
        var focusedYear = this.focusedDay.getFullYear();
        var minDate = DatePickerUtils_1.parseISODate(min);
        var maxDate = DatePickerUtils_1.parseISODate(max);
        var prevMonthDisabled = minDate != null && minDate.getMonth() === focusedMonth && minDate.getFullYear() === focusedYear;
        var nextMonthDisabled = maxDate != null && maxDate.getMonth() === focusedMonth && maxDate.getFullYear() === focusedYear;
        var minYear = minDate ? minDate.getFullYear() : selectedYear - 10;
        var maxYear = maxDate ? maxDate.getFullYear() : selectedYear + 10;
        return (react_1.default.createElement(DatePickerWrapper_1.default, { className: 'date-picker ' + className },
            react_1.default.createElement(DatePickerInput_1.default, { dateFormatter: this.dateFormatLong, value: this.value, valueAsDate: this.valueAsDate, formattedValue: formattedDate, onInput: this.handleInputChange, onBlur: this.handleBlur, onFocus: this.handleFocus, onClick: this.toggleOpen, name: name, disabled: disabled, role: role, required: required, identifier: identifier, localization: localization, buttonRef: this.datePickerButton, inputRef: this.datePickerInput }),
            this.open && react_1.default.createElement(ClickLayer_1.default, { onClick: function () { return _this.hide(false); } }),
            react_1.default.createElement(Dialog_1.default, { className: (direction === 'left' && 'is-left') + " " + (this.open && 'is-active'), role: "dialog", "aria-modal": "true", "aria-hidden": this.open ? 'false' : 'true', "aria-labelledby": this.dialogLabelId },
                react_1.default.createElement(DialogContent_1.default, { className: "dialog-content", onKeyDown: this.handleEscKey, innerRef: this.dialogWrapperNode },
                    react_1.default.createElement(Mobile_1.default, { className: "mobile", onFocus: this.disableActiveFocus },
                        react_1.default.createElement(MobileHeading_1.default, { className: "mobile-heading" },
                            react_1.default.createElement(Translate_1.default, null, localization.calendarHeading)),
                        react_1.default.createElement(ButtonClose_1.default, { className: "close", innerRef: this.firstFocusableElement, onKeyDown: this.handleFirstFocusableKeydown, onClick: function () { return _this.hide(); }, type: "button" },
                            react_1.default.createElement(Image_1.default, { "aria-hidden": true, asset: 'base.datePicker.close' }),
                            react_1.default.createElement("span", { className: "vhidden" },
                                react_1.default.createElement(Translate_1.default, null, localization.closeLabel)))),
                    react_1.default.createElement(Header_1.default, { className: "header", onFocus: this.disableActiveFocus },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("h2", { id: this.dialogLabelId, className: "vhidden", "aria-live": "polite", "aria-atomic": "true" },
                                react_1.default.createElement(Translate_1.default, null, localization.monthNames[focusedMonth]),
                                " ",
                                this.focusedDay.getFullYear()),
                            react_1.default.createElement("label", { htmlFor: this.monthSelectId, className: "vhidden" },
                                react_1.default.createElement(Translate_1.default, null, localization.monthSelectLabel)),
                            react_1.default.createElement(SelectWrapper_1.default, { className: "select" },
                                react_1.default.createElement(SelectMonth_1.default, { id: this.monthSelectId, value: focusedMonth, className: "select--month", innerRef: this.monthSelectNode, onChange: this.handleMonthSelect },
                                    react_1.default.createElement(Translate_2.TranslationContext.Consumer, null, function (translationContext) {
                                        var translate = translationContext.translate;
                                        return localization.monthNames.map(function (month, i) {
                                            var translatedMonth = translate(month);
                                            return react_1.default.createElement("option", { key: translatedMonth, value: i, disabled: !DatePickerUtils_1.inRange(new Date(focusedYear, i, 1), minDate ? DatePickerUtils_1.startOfMonth(minDate) : undefined, maxDate ? DatePickerUtils_1.endOfMonth(maxDate) : undefined) }, translatedMonth);
                                        });
                                    })),
                                react_1.default.createElement(SelectLabel_1.default, { className: "select-label", "aria-hidden": "true" },
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement(Translate_1.default, null, localization.monthNamesShort[focusedMonth])),
                                    react_1.default.createElement(Image_1.default, { "aria-hidden": true, asset: "base.datePicker.dropdown" }))),
                            react_1.default.createElement("label", { htmlFor: this.yearSelectId, className: "vhidden" },
                                react_1.default.createElement(Translate_1.default, null, localization.yearSelectLabel)),
                            react_1.default.createElement(SelectWrapper_1.default, { className: "select" },
                                react_1.default.createElement(SelectYear_1.default, { id: this.yearSelectId, value: focusedYear, className: "select--year", onChange: this.handleYearSelect }, range(minYear, maxYear).map(function (year) { return (react_1.default.createElement("option", { key: year }, year)); })),
                                react_1.default.createElement(SelectLabel_1.default, { className: "select-label", "aria-hidden": "true" },
                                    react_1.default.createElement("span", null, this.focusedDay.getFullYear()),
                                    react_1.default.createElement(Image_1.default, { "aria-hidden": true, asset: "base.datePicker.dropdown" })))),
                        react_1.default.createElement(NavigationWrapper_1.default, { className: "nav" },
                            react_1.default.createElement(ButtonPrevious_1.default, { className: "prev", onClick: this.handlePreviousMonthClick, disabled: prevMonthDisabled, type: "button" },
                                react_1.default.createElement(Image_1.default, { "aria-hidden": true, asset: "base.datePicker.previousMonth" }),
                                react_1.default.createElement("span", { className: "vhidden" },
                                    react_1.default.createElement(Translate_1.default, null, localization.prevMonthLabel))),
                            react_1.default.createElement(ButtonNext_1.default, { className: "next", onClick: this.handleNextMonthClick, disabled: nextMonthDisabled, type: "button" },
                                react_1.default.createElement(Image_1.default, { "aria-hidden": true, asset: "base.datePicker.nextMonth" }),
                                react_1.default.createElement("span", { className: "vhidden" },
                                    react_1.default.createElement(Translate_1.default, null, localization.nextMonthLabel))))),
                    react_1.default.createElement(DatePickerMonth_1.default, { dateFormatter: this.dateFormatShort, selectedDate: this.valueAsDate, focusedDate: this.focusedDay, onDateSelect: this.handleDaySelect, onKeyboardNavigation: this.handleKeyboardNavigation, labelledById: this.dialogLabelId, localization: localization, firstDayOfWeek: firstDayOfWeek, focusedDayRef: this.processFocusedDayNode, min: minDate, max: maxDate, isDateDisabled: isDateDisabled })))));
    };
    __decorate([
        mobx_1.observable.ref
    ], DatePicker.prototype, "activeFocus", void 0);
    __decorate([
        mobx_1.observable.ref
    ], DatePicker.prototype, "focusedDay", void 0);
    __decorate([
        mobx_1.observable.ref
    ], DatePicker.prototype, "open", void 0);
    __decorate([
        mobx_1.observable.ref
    ], DatePicker.prototype, "value", void 0);
    __decorate([
        mobx_1.observable.ref
    ], DatePicker.prototype, "valueAsDate", void 0);
    __decorate([
        mobx_1.action
    ], DatePicker.prototype, "createDateFormatters", void 0);
    __decorate([
        mobx_1.action
    ], DatePicker.prototype, "show", void 0);
    __decorate([
        mobx_1.action
    ], DatePicker.prototype, "hide", void 0);
    __decorate([
        mobx_1.action
    ], DatePicker.prototype, "enableActiveFocus", void 0);
    __decorate([
        mobx_1.action
    ], DatePicker.prototype, "disableActiveFocus", void 0);
    __decorate([
        mobx_1.action
    ], DatePicker.prototype, "setFocusedDay", void 0);
    __decorate([
        mobx_1.action
    ], DatePicker.prototype, "handleInputChange", void 0);
    __decorate([
        mobx_1.action
    ], DatePicker.prototype, "setValue", null);
    __decorate([
        mobx_1.action
    ], DatePicker.prototype, "processFocusedDayNode", void 0);
    DatePicker = __decorate([
        mobx_react_1.observer
    ], DatePicker);
    return DatePicker;
}(shared_1.ComponentBase));
exports.DatePicker = DatePicker;
exports.default = shared_1.InjectedStyledComponent(DatePicker, DatePicker_meta_1.DATE_PICKER_CATEGORY_KEY, DatePicker_meta_1.DATE_PICKER_COMPONENT_KEY);
